import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function get(page, query) {
  return request({
    url:    `/page/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   query
  });
}

function create(values) {
  return request({
    url:    '/page/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function update(id, values) {
  return request({
    url:    `/page/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
}

function find(id) {
  return request({
    url:    `/page/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function findAll() {
  return request({
    url:    '/page/list/filter/all',
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function remove(id) {
  return request({
    url:    `/page/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
}

function findComponentsByPageId(id) {
  return request({
    url:    `/page-component/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

const PageService = {
  get, create, update, remove, find, findAll, findComponentsByPageId
}

export default PageService;
